import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Location} from '@angular/common';
import {User} from '../../../interfaces/user';
import {GeneralFormComponent} from '../../general/form/generalForm.component';
import {MessageService} from '../../../../shared/message.service';
import {QuestionService} from '../../../services/question.service';
import {QuestionControlService} from '../../../services/question-control.service';
import {UserService} from '../../../services/user.service';

@Component({
  selector: 'qm-user-group-details',
  templateUrl: 'user-form.component.html',
  styleUrls: ['user-form.component.css']
})
export class UserFormComponent extends GeneralFormComponent<User> implements OnInit {

  private tenantId: string; // The id of the user's tenant. Must be given to rest when making request

  selectedGroupsFromRest: string[] = [];
  updatedGroups: string[] = [];

  constructor(
    route: ActivatedRoute,
    location: Location,
    messagesService: MessageService,
    router: Router,
    questionService: QuestionService,
    userService: UserService,
    questionControlService: QuestionControlService
  ) {
    super(route, userService, location, messagesService, router, questionService, questionControlService,
      {
        entityNameSingular: 'user',
        entityNamePlural: 'users',
        formUrl: 'user',
        listUrl: 'users',
        generalFormMetaName: 'user'
      });
  }

  /**
   * Fetches the entity from the rest by using fetchEntity function of super. If not new
   * then user right groups are taken set to local variable.
   */
  async fetchEntity(): Promise<void> {
    await super.fetchEntity();
    if (!this.isNew()) {
      if (this.entity.app_metadata && this.entity.app_metadata['right_groups']) {
        this.entity.app_metadata['right_groups'].forEach(groupName => {
          this.selectedGroupsFromRest.push(groupName);
        });
      }
    }
  }

  /**
   * When groupIds have been changed.
   * @param ids New ids.
   */
  groupIdsChanged(ids: string[]): void {
    this.updatedGroups = ids;
  }

  /**
   * Returns an object for form group.
   * @param {ENTITY} entity The entity from which the values are taken.
   * @returns {any} The entity to be used as form group value.
   */
  getFormObject(user: User): any {
    const formObject: any = super.getFormObject(user);
    formObject.tenant_id = this.tenantId;
    return formObject;
  }

  /**
   * Sets values from form entity to the entity that is sent to rest.
   * @param {ENTITY} entity The entity to which the values are set.
   * @param formEntity The form entity from which the values are taken.
   */
  updateEntityValues(entity: User, formEntity: any): void {
    Object.keys(formEntity).forEach((key: string) => {
      entity[key] = formEntity[key];
    });
    if (!entity.app_metadata) {
      entity['app_metadata'] = {};
    }
    entity.app_metadata['right_groups'] = this.updatedGroups;
  }

  /**
   * Return the id of the user being modified.
   * @param entity The user entity from which the id is taken.
   */
  protected getIdOfEntity(entity: User): string {
    return entity ? '' + entity['user_id'] : null;
  }

  /**
   * Returns the tenantId of the user that is being modified.
   */
  getRestParameters(): { key: string, value: string }[] {
    return [{key: 'tenantId', value: this.tenantId}];
  }

  /**
   * Initializes the view. Fetches the data from backend and questions for UI building.
   * @returns {Promise<void>} When done.
   */
  public async ngOnInit() {
    this.tenantId = this.route.snapshot.queryParamMap.get('tenantId');
    if (!this.tenantId) {
      this.messagesService.addWarning('TenantId missing in user form. Form not initialized.');
      console.error('TenantId missing in user form.');
      return;
    }
    await super.ngOnInit();
  }
}
